import Vue from "vue";
import dateFormatter from "@/mixins/dateFormatter";

export default Vue.extend({
  template: `
      <span>
        {{ formattedDate }}
      </span>
    `,
  computed: {
    formattedDate() {
      return dateFormatter.usDateTime(this.params.value);
    }
  },
  methods: {}
});
